import DepoistList from './deposit'
export default DepoistList
